import { addOptional } from 'Phaser/util';
import { VoiceGraphic } from '.';
import Clef from './Clef';

export interface MeasureDataExtra {
  firstNoteRelativeOffset: number;
  width: number;
  left: number;
  extraGap: number;
}

export default class ClefMeasure extends Phaser.GameObjects.Container {
  measureData: MeasureDataExtra;
  notes: VoiceGraphic[];
  clef: 'bass' | 'treble';
  offset: number;

  constructor(
    scene: Phaser.Scene,
    data: MeasureDataExtra,
    notes: VoiceGraphic[],
    pitchLineGap: number,
    clef: 'bass' | 'treble',
    parent: Clef,
  ) {
    super(scene);
    scene.add.existing(this);
    this.clef = clef;
    this.measureData = data;
    this.notes = notes;
    this.notes.forEach((n) => this.add(n));
    this.offset = data.extraGap + data.firstNoteRelativeOffset;
    this.resize(data.width, data.left, pitchLineGap, data.firstNoteRelativeOffset, data.extraGap);
    parent.add(this);
  }

  resize(xScale: number, xOffset: number, pitchLineGap: number, gap: number, extraGap: number) {
    this.offset = gap + extraGap;
    this.setX(xOffset + gap + extraGap);
    const fullWidth =
      this.measureData.width * xScale + this.measureData.firstNoteRelativeOffset + extraGap;
    this.notes.forEach((n) =>
      n.resize(
        pitchLineGap,
        xScale,
        fullWidth - extraGap,
        this.measureData.firstNoteRelativeOffset,
      ),
    );
    return fullWidth;
  }

  getOffset() {
    return this.offset;
  }

  destroy(_fromScene?: boolean): void {
    this.notes.forEach((n) => n.destroy());
    this.notes.clear();
  }

  getFirstNote(): VoiceGraphic | undefined {
    let minX = -Infinity;
    let minNote: VoiceGraphic | undefined = undefined;
    this.notes.forEach((n) => {
      if (minX < n.getPosition().x) {
        minX = n.getPosition().x;
        minNote = n;
      }
    });
    return minNote;
  }

  getFirstNotePosition(): number | undefined {
    return addOptional(this.getFirstNote()?.x, this.x);
  }
}
